import styled from 'styled-components'
import { Box, Flex, Input, getPaletteColor } from 'pcln-design-system'

const CalendarCloseBanner = styled(Flex)`
  position: fixed;
  top: 0px;
  left: 0;
  z-index: 11;
  height: 60px;
  width: 100%;
  ${(props) => props.theme.mediaQueries.md} {
    display: none;
  }
`
const CalendarContainer = styled(Box)`
  z-index: 10;
  position: fixed;
  top: 60px;
  right: 0px;
  width: 100%;
  ${(props) => `
      ${props.theme.mediaQueries.md} {
        position: absolute;
        top: 50px;
        width: initial;
      }
    `}
`

const StyledInput = styled(Input)`
  &[readOnly] {
    background-color: transparent;
    color: ${getPaletteColor('text.base')};
    cursor: pointer;
  }
`

export { CalendarContainer, CalendarCloseBanner, StyledInput }
